import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { Observable, Subscriber, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';
import { MobileService } from './mobile.services';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private httpClient: HttpClient,
    private router: Router,
    private keycloakService: KeycloakService,
    private mobileService: MobileService) { }

  public redirectUrl: string = 'welcome/appnavigator';
  private entitlements: string[] = [];
  public ignorePathList: string[] = ['dashboard'];

  private tokenRefreshFunc;

  isLoggedIn() {
    let accessToken = sessionStorage.getItem('access_token');
    return accessToken != undefined && accessToken != null;
  }
 
//   setToken(access_token){
//     sessionStorage.setItem('access_token',access_token)
//     let jwtToken = this.decodeJwt(access_token);
//     console.log("11111111111",jwtToken)
//   }

//    decodeJwt (token) {
//     var base64Url = token.split('.')[1];
//     var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//     var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
//         return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//     }).join(''));

//     return JSON.parse(jsonPayload);
// }



  // async login(userCredentials: { username: string, password: string }, forTokenRefresh = false) {
  //   let headers = {
  //     'Content-Type': 'application/json',
  //     'Authorization': 'my-auth-token',
  //   };

  //   let httpOpts: {
  //     headers: HttpHeaders,
  //     observe: any,
  //   } = {
  //     headers: new HttpHeaders(headers),
  //     observe: "response"
  //   };

  //   let url = encodeURI(environment.baseURL + '/common/login');

  //   clearTimeout(this.tokenRefreshFunc);

  //   let apiResponse: HttpResponse<any> | HttpErrorResponse;

  //   await this.httpClient.post(url, JSON.stringify(userCredentials), httpOpts).toPromise().then(
  //     (httpResponse: HttpResponse<any>) => {
  //       apiResponse = httpResponse;
  //       let resBody = httpResponse.body;
  //       sessionStorage.setItem('access_token', resBody['access_token']);
  //       sessionStorage.setItem('refresh_token', resBody['refresh_token']);

  //       if (!forTokenRefresh) {
  //         this.router.navigateByUrl(this.redirectUrl);
  //         this.redirectUrl = 'home/dashboard';
  //       }

  //       // if(resBody['expires_in']!=undefined){
  //       //   let expireTime =  typeof resBody['expires_in'] == "number"?resBody['expires_in']: +resBody['expires_in'];
  //       //   this.tokenRefreshFunc = setTimeout(
  //       //     () => {
  //       //       if(this.isLoggedIn()){
  //       //         this.login(userCredentials, true);
  //       //       }
  //       //     }, 10 * 1000);
  //       // }
  //     },
  //     (httpError: HttpErrorResponse) => {
  //       apiResponse = httpError;
  //     }
  //   )

  //   return apiResponse;
  // }

  async logout() {
    console.log("logout...");
    var redirectUri = window.location.origin + window.location.pathname + '#/' + this.redirectUrl;
    if(this.mobileService.isHybrid()){
      redirectUri = '';
    }
    this.keycloakService.logout(redirectUri);
  }

  async getUIEntitlements() {
    if (this.entitlements.length > 0) {
      return this.entitlements;
    }

    // await of(['MstEventMain', 'MstgridEdit', 'ProductGroupParent']).pipe(delay(1000)).toPromise().then(
    //   (resp) => this.entitlements = resp
    // )

    // return this.entitlements;

    let httpOpts = {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + sessionStorage.getItem('access_token') })
    }

    let url = encodeURI(environment.baseURL + '/common/publisher/scopeBasedPermission?scope=FPURI');

    await this.httpClient.get(url, httpOpts).toPromise().then(
      (response) => this.entitlements = response['Resources']
    );

    return this.entitlements;
  }

} 
